import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";
import { METRICS } from "../lib/data";

function Counter({ value, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 2,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return (
    <span ref={ref}>
      {display.toLocaleString()}
      {suffix}
    </span>
  );
}

export default function Metrics() {
  return (
    <section
      id="metrics"
      data-testid="metrics-section"
      className="relative py-24 md:py-32 px-6 md:px-12 lg:px-16 bg-[var(--bg-secondary)] border-y border-white/10"
    >
      <div className="mb-14 md:mb-20 max-w-4xl">
        <p className="text-xs md:text-sm font-bold uppercase tracking-[0.25em] text-[var(--accent-primary)]">
          Marketing, Advertising & PR Agency Performance Metrics
        </p>
        <h2 className="mt-5 font-display text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.02] text-white">
          Milestones that define our impact
        </h2>
        <p className="mt-6 max-w-2xl text-base md:text-lg text-zinc-400 leading-relaxed">
          Our journey is driven by performance, innovation, and measurable success.
          Every number reflects our commitment to delivering high-impact solutions
          that create real business growth.
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12 md:gap-y-16">
        {METRICS.map((m, i) => (
          <motion.div
            key={m.label}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
            data-testid={`metric-${i}`}
            className="border-t border-white/10 pt-6"
          >
            <div className="font-display text-5xl md:text-7xl lg:text-8xl font-black tracking-tighter text-white">
              <Counter value={m.value} suffix={m.suffix} />
            </div>
            <div className="mt-3 text-sm md:text-base font-medium text-zinc-400">
              {m.label}
            </div>
          </motion.div>
        ))}
      </div>
      <p className="mt-10 text-xs text-zinc-600">* Placeholder targets — editable.</p>
    </section>
  );
}
